var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({directives:[{name:"currency",rawName:"v-currency",value:(_vm.options),expression:"options"}],ref:"currencyField",attrs:{"rules":_vm.rulesArray},model:{value:(_vm.currencyValue),callback:function ($$v) {_vm.currencyValue=$$v},expression:"currencyValue"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }